import { readonly, ref } from 'vue'

const visible = ref(false)
const helpKey = ref('')

/** 打开情境帮助文章弹窗（全局单例状态）；调用方应先校验并 trim key */
export function openHelpArticleByKey(key: string) {
  if (!key) return false
  helpKey.value = key
  visible.value = true
  return true
}

export function closeHelpArticleDialog() {
  visible.value = false
}

/**
 * 情境帮助弹窗状态（App 根节点挂载 HelpArticleDialog，HelpLink 调用 openHelpArticleByKey）
 */
export function useHelpArticleDialog() {
  return {
    visible,
    helpKey: readonly(helpKey),
    openByKey: openHelpArticleByKey,
    close: closeHelpArticleDialog
  }
}
